export enum ItensMenuAdicionais {
    LiberacaoCnd = 'LiberacaoCnd',
    CnpjsVinculados = 'CnpjsVinculados',
    DeclaracaoIrpfMalha = 'DeclaracaoIrpfMalha'
}